module.exports = __webpack_public_path__ + "static/media/adam-hit.79ab5a92.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/adam-hit.png
// module id = 35
// module chunks = 0